import "./UserProfileBadge.scss";
import React from "react";
import { IconButton, MenuItem, ListItemIcon, Menu } from "@mui/material";
import Avatar from "./Avatar";
import ExitToApp from "@mui/icons-material/ExitToApp";
import Settings from "@mui/icons-material/Settings";
import { useAuth0 } from "../../auth/AuthContext";
import { Link } from "react-router-dom";

export default function UserProfileBadge(props) {
    const { user, logout } = useAuth0();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton id="btn-user-profile" aria-controls="user-menu" aria-haspopup="true" onClick={handleClick}>
                <Avatar className="small" src={user?.picture} alt={user?.name} fallback={user?.name} />
            </IconButton>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
            >
                <MenuItem disabled className="menu-header">{user?.name}</MenuItem>
                <MenuItem disabled className="menu-version">App Version: {__APP_VERSION__ ?? "Development Build"}</MenuItem>
                <hr />
                <Link to="/preferences">
                    <MenuItem onClick={handleClose}>
                        <ListItemIcon><Settings /></ListItemIcon>
                        Preferences
                    </MenuItem>
                </Link>
                <MenuItem onClick={() => logout({ postLogoutRedirectUri: window.location.href })}>
                    <ListItemIcon><ExitToApp /></ListItemIcon>
                    Log Out
                </MenuItem>
            </Menu>
        </>
    );
}